/*
Theme Object
https://rebassjs.org/theming/

| Key	Type	      | Description
| breakpoints     |	Viewport widths to use for min-width media queries.
| fontSizes	      | Array	Array of numbers - to use as a typographic scale
| colors	        | Names that can be used in color, bg, and borderColor props
| space	          | For use as margin and pixel values
| fonts	          | Array or Object	Values - for the fontFamily prop
| fontWeights	    | Array or Object	Values - for fontWeight prop
| lineHeights	    | Array or Object	Values - for lineHeight prop
| letterSpacings	| Array or Object	Values - for letterSpacing prop
| shadows	        | Array or Object	Values - for boxShadow prop
| borders	        | Array or Object	Values - for border props
| radii	          | Array or Object	Values - for borderRadius props
| opacity	        | Array or Object	Values - for opacity props

| Custom Types
| layout         | Object - define layout values and utils
| typography     | Object - define all typography related values
*/

import colors from './colors';
import breakpoints from './breakpoints';
import space from './space';
import fonts from './fonts';
import fontSizes from './fontSizes';
import layout from './layout';
import typography from './typography';
import radii from './radii';
import grid from './grid';

const theme = {
  colors,
  breakpoints,
  space,
  fonts,
  fontSizes,
  layout,
  typography,
  radii,
  grid,
};

export type AppTheme = typeof theme;

export default theme;
